import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AlertService } from '../../_alert';
import { DatastoreService } from '../../services/datastore.service';
import { MemberService } from '../../services/jrni/member.service';
import { ApiService } from '../../services/jrni/api.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
  selectedDepartment;
  pageTitle;
  calendarPageText;
  minDate;
  maxDate;
  selectedDate: Date;
  currentDate: Date;
  selectedService;
  selectedLocation;
  slots: [];
  selectedSlot;
  availableDays: any;
  component: String;
  bookingsLimit: String;

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private servicesService: ServicesService,
    private availabilityService: AvailabilityService,
    private alertService: AlertService,
    private basketService: BasketService,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService,
    private memberService: MemberService,
    private apiService: ApiService
  ) {
  }

  routerGoBack() {
    this.router.navigate(['/services']);
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  ngOnInit() {
    this.scrollToTop();
    this.component = "calendar";
    this.spinner.show();
    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.get().then(selectedDepartment => {
      if (selectedDepartment === undefined) {
        this.restartJourney();
      } else {
        this.selectedDepartment = selectedDepartment;

        this.departmentService.getLocation().then((selectedLocation) => {
          this.selectedLocation = selectedLocation
        })

        // this.selectedLocation = this.departmentService.getLocation();

        // Set the current date to today for the calendar to default to today
        this.currentDate = new Date();
        this.selectedDate = this.currentDate;

        // Get the configurable data
        if (this.selectedDepartment.hasOwnProperty('extra')) {
          // Set the title on the login page to the title from the business question
          this.selectedDepartment.extra.hasOwnProperty('calendar_page_title') ? this.pageTitle = this.selectedDepartment.extra.calendar_page_title : this.pageTitle = "Calendar title not set";
          // Set the extra text on the page to the text taken from the business question
          this.selectedDepartment.extra.hasOwnProperty('calendar_page_text') ? this.calendarPageText = this.selectedDepartment.extra.calendar_page_text : null;
        }

        // Retrieve the selected service
        this.servicesService.get().then(async (service) => {
          this.selectedService = service;

          // Clear the basket
          if (this.datastoreService.adminJourney) {
            this.datastoreService.originalCompanyId = this.selectedDepartment.id;
            console.log('Admin journey. Use v1');
            this.basketService.reassignCompany(this.selectedLocation).then((res) => {
              // this.basketService.deleteAllBaskets(this.selectedLocation).then(async (data) => {
              //   this.basketService.currentBasket = await this.basketService.createBasket(this.selectedLocation);
              //   console.log('Basket created', this.basketService.currentBasket);
              // }).catch((err) => {
              // this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
              // });
              console.log(res);
             })
          } 
          else {
            const basket = this.apiService.createBasket(this.selectedLocation).subscribe((response) => {
              if(response.headers.has('auth-token')) {
                const authToken = response.headers.get('auth-token');
                localStorage.setItem('auth_token', authToken);
                console.log(`Set auth token from basket: ${authToken}`);
              }
              this.basketService.currentBasket = response.body;
              console.log(this.basketService.currentBasket);
              this.spinner.hide();
            });
          }
        });
      }
    }, err => {
      this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
      this.spinner.hide();
    });
  }

  continue() {
    this.alertService.clear();
    this.availabilityService.getSelectedSlot().then(async (slot) => {
      if (slot) {
        // Store the selected date
        this.datastoreService.selectedDate = this.selectedDate;
        // Store the selected slot
        this.datastoreService.selectedSlot = slot;

        // now we add the item
        let resource;
        try {
          // Pass the resource id, not the whole resource object. The basket calls coerce
          // whatever they are given, but an object previously reached JRNI as
          // resource_id: null, and JRNI then silently assigns whatever resource is free at
          // that slot — booking the customer into the wrong room.
          resource = await this.availabilityService.getSelectedResource();
        }
        catch (err) {
          console.error(err);
          this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
          this.spinner.hide();
        }
        try {
          this.spinner.show();
          if (this.datastoreService.adminJourney) {
            console.log('Admin journey. Use v1');
            const res = await this.basketService.addItemV1(
              this.selectedLocation,
              this.selectedService.id,
              this.selectedService.calculated_duration,
              slot.start,
              [],
              false,
              resource
            );
            console.log(`Item added to basket`, res);
            this.basketService.currentServiceItem = res;
          }
          else {
            console.log(this);
            const serviceItem = await this.apiService.addServiceItem(
              this.selectedLocation, 
              this.basketService.currentBasket, 
              slot.start,
              this.selectedService,
              [],
              this.selectedService.calculated_duration,
              this.datastoreService.selectedSuggestion.resource_id
            );
            console.log(`Item added to basket`, serviceItem);
            this.basketService.currentServiceItem = serviceItem;
          }
          this.router.navigate(['/booking-details']);
        }
        catch (err) {
          console.error(err);
          this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
          this.spinner.hide();
        }
      } else {
        this.alertService.warn(this.translateService.instant('CALENDAR.SLOT_WARNING'));
        this.scrollToTop();
      }
    });
  }

  // scroll to the top of the page
  scrollToTop() {
    const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
    window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
  }
}
